import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, createBrowserRouter, HashRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import "./index.css";
// import "drawflow/dist/drawflow.min.css";
// import "../cssstyle/beautiful.css"; 

// import '@fontsource/nunito-sans/400.css';


import 'bootstrap/dist/css/bootstrap.min.css';
import { DialogProvider } from './context/DialogContext';
import { WebSocketProvider } from './context/UseWebSocketContext'
import { AuthProvider } from './context/auth';

import GoogleAuthProvider from './context/GoogleAuthProvider';
import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(
  <HelmetProvider>

    <AuthProvider>
      <HashRouter>
        <WebSocketProvider>
          <DialogProvider>
            <Provider store={store}>
              <GoogleAuthProvider>

                <App></App>
              </GoogleAuthProvider>


            </Provider>
          </DialogProvider>

        </WebSocketProvider>
      </HashRouter>
    </AuthProvider>
  </HelmetProvider>
);


reportWebVitals();
